<template>
  <div>
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" :width="100" />
        <table-header :title="$t('category.name')" :minWidth="100" />
        <table-header
          :title="$t('common.action')"
          :minWidth="100"
          :width="100"
        />
      </template>
      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.name }}</table-cell>
        <table-cell>
          <i class="el-icon-view icon" @click="handleViewDetail(row.id)" />
          <i class="el-icon-edit icon" @click="handleOpenEditDialog(row)" />
          <i
            class="el-icon-delete icon"
            @click="handleOpenDeleteDialog(row.id)"
          />
        </table-cell>
      </template>
    </table-component>

    <span v-if="categorySelected">
      <edit-dialog
        :category="categorySelected"
        :openEditDialog="openEditDialog"
        @handleCloseEditDialog="handleCloseEditDialog"
      />
    </span>

    <delete-dialog
      :title="null"
      :content="$t('category.deleteTitle')"
      :openDeleteDialog="openDeleteDialog"
      :deleteLoading="deleteCategoryLoading"
      @handleCloseDialog="handleCloseDeleteDialog"
      @handleConfirm="handleDeleteCategory"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { categoryService } from '@/services/category.service';
import { handleError, notifyMessage, redirectRouter } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import * as pageRouter from '@/constants/pageRouter';

const EditDialog = () => import('../EditCategoryDialog');
const DeleteDialog = () => import('@/components/Dialog/DialogConfirm.vue');

export default {
  name: 'TableListCategory',
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  components: { EditDialog, DeleteDialog },
  data() {
    return {
      deleteCategoryLoading: false,
      categorySelected: null,
      categoryIdSelected: null,
      openDeleteDialog: false,
      openEditDialog: false,
      LIMIT,
    };
  },
  computed: {
    ...mapGetters('category', ['category']),
  },
  methods: {
    ...mapActions('category', ['getCategoryList']),
    handleOpenDeleteDialog(categoryId) {
      this.categoryIdSelected = categoryId;
      this.openDeleteDialog = true;
    },
    handleCloseDeleteDialog() {
      this.openDeleteDialog = false;
    },
    handleDeleteCategory() {
      this.deleteCategoryLoading = true;

      categoryService
        .delete(this.categoryIdSelected)
        .then(() => {
          const categoryLength = this.category.data.length - 1;

          this.getCategoryList({
            name: this.$route.query.categoryName,
            page:
              categoryLength === 0 && +this.$route.query.pageNumber > 1
                ? +this.$route.query.pageNumber - 1
                : this.$route.query.pageNumber || PAGE,
            limit: LIMIT,
          });

          redirectRouter({
            path: pageRouter.CATEGORY,
            query: {
              ...this.$route.query,
              pageNumber:
                categoryLength === 0 && +this.$route.query.pageNumber > 1
                  ? +this.$route.query.page - 1
                  : this.$route.query.page,
            },
          });
          this.openDeleteDialog = false;
          notifyMessage(this.$t('common.deleteSuccess'), 'success');
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.deleteCategoryLoading = false;
        });
    },
    handleOpenEditDialog(category) {
      this.categorySelected = category;
      this.openEditDialog = true;
    },
    handleCloseEditDialog() {
      this.openEditDialog = false;
    },
    handleViewDetail(id) {
      redirectRouter({
        path: `/categories/${id}/sub-categories`,
        query: {
          categoryName: this.$route.query.categoryName,
          pageNumber: this.$route.query.pageNumber,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.list-category {
  thead {
    th.el-table__cell.is-leaf:nth-child(3) {
      text-align: center;
    }
  }
  tbody {
    .el-table__cell:last-child {
      text-align: center;
    }
  }
}
</style>
